import React from "react";
import "./Re_fresh.css";
import { useEffect } from "react";
import { useState } from "react";

import useControlPanel from "src/hooks/useControlPanel";
import Pagination from "src/components/Pagination/Pagination";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import useAuth from "src/hooks/useAuth";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useDebounce from "src/hooks/useDebounce";
import {
  deleteRefresh,
  getKeyGenerate,
  getRefresh,
} from "src/apis/System/_re_fresh.api";
import ReFreshGenerateKeyPopup from "../../components/Popup/Re_fresh/ReFreshGenerateKeyPopup";
import RefreshChangeKeyPopup from "../../components/Popup/Re_fresh/RefreshChangeKeyPopup";
import RefreshViewDetailPopup from "../../components/Popup/Re_fresh/RefreshViewDetailPopup";
import ReFreshControlPanel from "../../components/ControlPanel/ReFreshControlPanel";
import { path } from "src/constants/path";
import {
  allowedShowAction,
  allowedToDeleteEntity,
  allowedToReadEntity,
} from "src/constants/role";
import { Notify, NotifyConfirm } from "src/components/notify/Notify";

const initReFreshData = {
  list: [],
  total_record: 0,
};

const titlePage = "_Re_fresh";

/*===================================== GLOBAL =====================================*/
/**
 * Variables for UI
 */
const RefreshTableHead = ["String1", "Last Update", "Action"];
const renderHead = (item, index) => <th key={index}>{item}</th>;
const renderBody = (item, index) => (
  <tr key={index}>
    <td>{item.string1}</td>
    <td>{item.modifiedDate}</td>
    <td>{item.action}</td>
  </tr>
);

/*===================================== GLOBAL =====================================*/

const Re_fresh = () => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [dataGenerateKey, setDataGenerateKey] = useState({
    publicKey: "",
    privateKey: "",
  });
  const [refreshData, setRefreshData] = useState(initReFreshData);
  const [refreshDetail, setRefreshDetail] = useState(null);
  const [openPopupGenerateKey, setOpenPopupGenerateKey] = useState(false);
  const [openPopupChangeKey, setOpenPopupChangeKey] = useState(false);
  const [openPopupViewDetail, setOpenPopupViewDetail] = useState(false);
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };

    getRefresh(query, (result) => {
      setRefreshData({ ...result });
    });
  }, [endDate, limit, numberPage, page, search, startDate, status]);

  const handleDelete = (refreshDelete) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const refreshFilterData = refreshData.list.filter(
          (refresh) => refresh.id !== refreshDelete.id
        );

        setRefreshData((prev) => {
          return {
            ...prev,
            list: [...refreshFilterData],
          };
        });

        Notify("success", "Deleted!");
        deleteRefresh(refreshDelete.id);
      }
    });
  };

  const handleShowDetail = (item) => {
    setOpenPopupViewDetail(true);
    setRefreshDetail(item);
  };

  const handleGenerateKey = () => {
    getKeyGenerate((result) => {
      setDataGenerateKey({ ...result });
    });
  };

  const handleOpenPopupGenerateKey = (isOpen) => {
    setOpenPopupGenerateKey(isOpen);
    getKeyGenerate((result) => {
      setDataGenerateKey({ ...result });
    });
  };

  /**
   *************************** RETURN UI *************************
   */
  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      {/* Popup Generate Key */}
      <ReFreshGenerateKeyPopup
        title="Detail Key Generate"
        openPopup={openPopupGenerateKey}
        setOpenPopup={setOpenPopupGenerateKey}
        dataGenerateKey={dataGenerateKey}
      />

      {/* Popup Change Key */}
      <RefreshChangeKeyPopup
        title={"Change Key"}
        openPopup={openPopupChangeKey}
        setOpenPopup={setOpenPopupChangeKey}
      />

      {/* Popup View Detail */}
      <RefreshViewDetailPopup
        title="Detail"
        openPopup={openPopupViewDetail}
        setOpenPopup={setOpenPopupViewDetail}
        refreshDetail={refreshDetail}
      />

      <ReFreshControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleGenerateKey={handleGenerateKey}
        setOpenPopupChangeKey={setOpenPopupChangeKey}
        handleOpenPopupGenerateKey={handleOpenPopupGenerateKey}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </ReFreshControlPanel>

      {/* Table */}
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card__body">
              <div className="table-wrapper">
                <table className="tableFixed">
                  {/* Table Head */}
                  {RefreshTableHead && renderHead ? (
                    <thead>
                      <tr>
                        {RefreshTableHead.map((item, index) => {
                          if (
                            !allowedShowAction(
                              auth?.permissions,
                              permissionsAccessControl
                            ) &&
                            item === "Action"
                          ) {
                            return null;
                          }
                          return renderHead(item, index);
                        })}
                      </tr>
                    </thead>
                  ) : null}

                  {/* Table Body */}
                  {refreshData && renderBody ? (
                    <tbody>
                      {refreshData.list.map((item, index) => (
                        <tr key={index}>
                          <td className="tdFixed">{item.string1}</td>
                          <td>
                            {" "}
                            {item?.modifiedDate
                              ? `${new Date(
                                  item.modifiedDate
                                ).toLocaleTimeString("en-GB")} ${new Date(
                                  item.modifiedDate
                                ).toLocaleDateString("en-GB")}`
                              : ""}
                          </td>
                          <td>
                            {/* Button--Action View Detail */}
                            {allowedToReadEntity(
                              auth?.permissions,
                              permissionsAccessControl
                            ) && (
                              <button
                                className="btn btn-success"
                                onClick={() => {
                                  handleShowDetail(item);
                                }}
                              >
                                <i className="bx bx-show"></i>
                              </button>
                            )}

                            {/* Button--Action Delete */}
                            {allowedToDeleteEntity(
                              auth?.permissions,
                              permissionsAccessControl
                            ) && (
                              <button
                                onClick={() => handleDelete(item)}
                                className="btn btn-danger"
                              >
                                <i className="bx bx-trash"></i>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Pagination
        pathname={path.systemRefresh}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={refreshData.total_record || 1}
      />
    </div>
  );
};

export default Re_fresh;
